<script>
import Card from '@/components/app/Card.vue';

export default {
  name: 'CardWithBack',

  components: {
    Card,
  },

  props: {
    card: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <div class="card-container ">
    <v-sheet elevation="1" class="cardback" :class="card.category" />

    <Card :card-draft="card" />
  </div>
</template>

<style lang="scss" scoped>
.card-container {
  position: relative;
  // width: 360px;
  height: 620px;
  // margin: 0 auto;
  // padding: 20px 100px 32px 100px;
  padding: 20px 20px 32px 100px;
  background-color: transparent !important;

  .landing & {
    // width: 320px;
    min-height: 580px;
    height: fit-content;
    padding-left: 80px;
    background-color: transparent !important;

    .sm & {
      // width: calc(100vw - 4rem);
      padding: 0;
      margin: 1rem;
    }
  }
}

.fullscreen {
  position: relative;
}

.cardback {
  position: absolute;
  box-sizing: border-box;
  width: 360px;
  height: 620px;
  padding: 1rem;
  border-radius: 10px;
  transform: rotate(-10deg) translateX(-30px);
  background-image: url('~@/assets/backgrounds/BlueBackground.svg?external');
  background-repeat: no-repeat;
  background-size: cover;

  .landing & {
    width: 320px;
    height: 580px;

    .sm & {
      // width: calc(100vw - 4rem);
      transform: rotate(-6deg) translateX(0px);
    }
  }

  &.deepening {
    background-image: url('~@/assets/backgrounds/PurpleBackground.svg?external');
  }

  &.lightening {
    background-image: url('~@/assets/backgrounds/YellowBackground.svg?external');
  }
}
</style>
